import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { Text, Header, Heading } from "rsuite";


export class Respuesta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      curp: localStorage.getItem("curp"),
      fecha: this.getCookie("fecha"),
      anio: 2026,
    };
  }
  
  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  render() {
    const { params, curp, fecha, anio } = this.state;
    const { location, history } = this.props;

    return (
      <div className="App container" style={{ marginTop: "50px" }}>
        <center>
          <Image
            src={`Images/Logo1.jpg?v=${new Date().getTime()}`}
            width={"180px"}
            height={"140px"}
          />
        </center>
        <div className="responsive-container" style={{ textAlign: "center" }}>
          <Header
            style={{
              backgroundColor: "#f9f7f6",
              height: "auto",
              padding: "5px",
              borderRadius: "15px",
            }}
          >
            <div className="card">
              <Text size={"2xl"} weight="semibold">
                !Gracias por tu registro!
              </Text>
            </div>
            <div className="card">
              <Text size={"lg"}>
                Te esperamos en esta gran carrera, el próximo: <br></br>
                <b>
                  {fecha}, {anio}
                </b>
              </Text>
            </div>
            <div className="card">
              <Text>La información de tu inscripción será revisada en caso de existir alguna duda nos comunicaremos contigo.</Text>
            </div>
            <div className="card" style={{ textAlign: "center" }}>
              <a
                href={`/#/registro/confirmado/curp=${localStorage.getItem("curp")}`}
                style={{ fontSize: "18px" }}
              >
                Descarga aqui tu responsiva ({localStorage.getItem("curp")})
              </a>
            </div>
            <div className="card">
              <Text size={"sm"}>Soporte técnico, envía whatsapp al 444.256.08.50</Text>
            </div>
          </Header>
        </div>
      </div>
    );
  }
}
